// src/utils/debugUtils.ts
import { logger } from '../lib/logger';

export function debugLoadingState() {
  logger.debug('Debug loading state', {
    category: 'Debug',
    data: {
      url: window.location.href,
      pathname: window.location.pathname,
      hotelConfig: window.HOTEL_CONFIG,
      appMounted: window.__APP_MOUNTED,
      navigatorOnline: navigator.onLine,
      timestamp: new Date().toISOString(),
      memory: performance.memory ? {
        jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
        totalJSHeapSize: performance.memory.totalJSHeapSize,
        usedJSHeapSize: performance.memory.usedJSHeapSize
      } : 'Not available'
    }
  });
}

export function monitorNetworkStatus() {
  window.addEventListener('online', () => {
    logger.debug('Network connection restored', {
      category: 'Network',
      data: { timestamp: new Date().toISOString() }
    });
  });

  window.addEventListener('offline', () => {
    logger.warn('Network connection lost', {
      category: 'Network',
      data: { timestamp: new Date().toISOString() }
    });
  });
}